<!--  -->
<template>
  <v-menu
    v-model="shown"
    bottom
    right
    offset-y
    :close-on-content-click="false"
    max-height="calc(100% - 16px)"
    max-width="1000"
    nudge-left="200"
    transition="slide-y-transition"
  >
    <template v-slot:activator="{ on: menu }">
      <v-btn text v-on="menu" min-width="48">
        <span class="subtitle-1 text-capitalize font-weight-light">教程分类</span>
        <v-icon right class="hidden-sm-and-down">mdi-menu-down</v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-container>
        <v-row align="start" justify="start">
          <template v-for="item in items">
            <v-col cols="auto" :key="item.text">
              <base-link-item v-bind="item" @click="shown = false"></base-link-item>
            </v-col>
          </template>
        </v-row>
      </v-container>
    </v-card>
  </v-menu>
</template>

<script>
export default {
  name: "BaseTutorialMenu",
  components: {},
  
  data: () => ({
    shown: false,
    items: [
      {
        to: "academic",
        icon: "mdi-library",
        text: "学术教程",
        chip: "deprecated"
      },
      {
        to: "big_data",
        icon: "mdi-server-network",
        text: "大数据分析",
        chip: "new"
      },
      {
        to: "computer_programming",
        icon: "mdi-code-braces",
        text: "电脑编程",
        chip: "help"
      },
      {
        to: "database",
        icon: "mdi-database",
        text: "数据库",
        chip: "updated"
      },
      {
        to: "devops",
        icon: "mdi-shield-account",
        text: "开发运维"
      },
      {
        to: "scripting_language",
        icon: "mdi-script",
        text: "脚本语言"
      },
      {
        to: "software_quality",
        icon: "mdi-diamond-stone",
        text: "软件质量"
      },
      {
        to: "computer_science",
        icon: "mdi-desktop-classic",
        text: "计算机科学"
      },
      {
        to: "engineering",
        icon: "mdi-tower-beach",
        text: "工程教程",
        chip: "new"
      },
      {
        to: "exams",
        icon: "mdi-pen",
        text: "考试大纲"
      },
      {
        to: "machine_leaning",
        icon: "mdi-robot",
        text: "机器学习"
      },
      {
        to: "latest_technologies",
        icon: "mdi-radioactive",
        text: "最新技术"
      },
      {
        to: "management",
        icon: "mdi-reminder",
        text: "管理教程"
      },
      {
        to: "maths",
        icon: "mdi-sigma",
        text: "数学教程"
      },
      {
        to: "digital_marketing",
        icon: "mdi-chart-areaspline",
        text: "数字营销"
      },
      {
        to: "misc_tutorials",
        icon: "mdi-format-list-bulleted",
        text: "杂项教程"
      },
      {
        to: "soft_skill",
        icon: "mdi-comment-multiple-outline",
        text: "软技能"
      },
      {
        to: "questions_and_answers",
        icon: "mdi-account-tie",
        text: "面试问题"
      }
    ]
  }),

  computed: {

  },

  methods: {},

  mounted() {}
};
</script>

<style lang='scss' scoped>
</style>